// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3oVpz","description":"PatientConsentPreview_description__3htRr"};